import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const  noticeAdminRouter: Array<RouteRecordRaw> = [
    {
        path: '/notice-admin',
        name: '站内通知管理',
        component: Layout,
        meta: { title: '站内通知管理', icon: 'icon-pie', alwaysShow: true },
        children: [
            {
                path: 'group-msg-list',
                name: '群通知列表',
                component: () => import('@/views/merchant/GroupMsgList.vue'),
                meta: { title: '群通知列表' }
            },
            {
                path: 'group-msg-edit',
                name: '群通知编辑',
                component: () => import('@/views/merchant/GroupMsgEdit.vue'),
                meta: { title: '群通知编辑' }
            },
            {
                path: 'training-list',
                name: '平台教程',
                component: () => import('@/views/merchant/TrainingList.vue'),
                meta: { title: '平台教程', keepAlive: true, depth: 30 }
            },
            {
                path: 'standard-list',
                name: '后台通知列表',
                component: () => import('@/views/merchant/StandardList.vue'),
                meta: { title: '后台通知列表' }
            },{
                path: 'standard-edit',
                name: '后台通知编辑',
                component: () => import('@/views/merchant/StandardEdit.vue'),
                meta: { title: '后台通知编辑' }
            },
            {
                path: 'standard-edit',
                name: '后台通知编辑',
                component: () => import('@/views/merchant/StandardEdit.vue'),
                meta: { title: '后台通知编辑' }
            },
        ]
    }
]

export default noticeAdminRouter